/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
//import { mjt } from './i18ntexts.js';

import { htmlspecialchars } from './util.js';
import { MCUnknown } from './media.unknown.js';
import { MThumbnails } from './thumbnails.js';

import { getModelViewerAutoDimensionsHTML, getModelViewerAutoDimensionsStyle, setupModelViewerAutoDimensions } from './modelviewer-auto-dimensions.js';
import { disableMediaViewBGCtrlsToolbar, setupMediaViewBGCtrlsToolbar } from './media-view-bg-ctrls-toolbar.js';
import { ToolbarSetupUtil } from './media-view-toolbar-util.js';

// // eslint-disable-next-line no-unused-vars
// import { ModelViewerElement } from '../entry/model-viewer.js';


export let MCModel = function($,mj) {

	const media_class = 8;

	// const m_model_viewer_module = {
	// 	ModelViewerElement,
	// };

	let m_model_viewer_module = null;
	function loadModelViewerModule( on_loaded_cb ) {
		if( m_model_viewer_module ) {
			return on_loaded_cb(m_model_viewer_module);
		}
		return import('../entry/model-viewer.js')
			.then( (module) => {
				m_model_viewer_module = module;
				return on_loaded_cb(m_model_viewer_module);
			} )
			.catch( (error) => {
				console.error(error);
			} );
	}



	function createPreview_GLTF( dtinfo, target, xopts, toolbarSetupUtil ) {
		const meta = dtinfo.meta;
		const md_trg = $(target);
		const media_id = dtinfo.media_id;
		let $md_modelviewer = null;

		let md_view_w = Math.max( 10, md_trg.width()-10 );
		let md_view_h = Math.max( 10, md_trg.height()-10 );

		let m_createdPosterUrl = '';
		let m_createPosterImagePromise = null;

		function close_handler( e, unbind ) {
			invalidateCreatedPosterUrl();
			if( $md_modelviewer ) {
				$md_modelviewer.remove();
				$md_modelviewer = null;
			}
			if( unbind ) md_trg.off('.MCModel');
		}


		function invalidateCreatedPosterUrl() {
			if( m_createPosterImagePromise!=null ) {
				// console.log({w:'abort??? m_createPosterImagePromise',m_createdPosterUrl,m_createPosterImagePromise});
				return;
			}
			if( m_createdPosterUrl!='' ) {
				// console.log({w:'invalidate m_createdPosterUrl',m_createdPosterUrl,m_createPosterImagePromise});
				URL.revokeObjectURL(m_createdPosterUrl);
				m_createdPosterUrl = '';
			}
		}

		function resize_handler(e,w,h) {
			// save new viewport dimensions
			md_view_w = Math.max(10,w-10);
			md_view_h = Math.max(10,h-10);
			// show
			// show_preview(false,false);

			// toggle download button for poster images
			toolbarSetupUtil.withToolbar( function( toolbar ) {
				if( !dtinfo.r_download && toolbar!==null ) {
					$('.mdb-download-i',toolbar).toggle(dtinfo.r_download);
				}
			} );
		}


		let poster_src = '';
		if( !xopts.no_poster_bg ) {
			const view_w = Math.max(10,Math.min(2*1920,md_view_w));
			const view_h = Math.max(10,Math.min(2*1080,md_view_h));
			const src_dim = mj.mc_ns[media_class].getSourceDimensions(dtinfo);
			const dsp_dim = MThumbnails.getImageDimsScaledToBox2(view_w,view_h,src_dim[0],src_dim[1],true);
			const dsp_w = Math.max(view_w,dsp_dim[0]);
			const dsp_h = dsp_dim[1];
			const poster_h = Math.max(10,dsp_h);
			poster_src = mj.mc_ns[media_class].getPosterImageSrc(dtinfo,dsp_w,poster_h,false);
		}


		const file_sfx = meta && meta[6] && meta[6].length ? meta[6][0] : null;
		const mq = 'm='+encodeURIComponent(dtinfo.meta[-4]?dtinfo.meta[-4][0]:'');
		const vq = !dtinfo.is_latest_version ? 'version='+encodeURIComponent(dtinfo.version) : '';
		const rq = '?'+mq+'&'+vq;
		const url = mj.fixAssetURL(mj.webroot+'media/file/get/id/'+media_id+'.'+file_sfx+rq);

		let modelviewer_html = '<model-viewer class="md-model" shadow-intensity="1" camera-controls';
		modelviewer_html += ' src="'+htmlspecialchars(url,true,true)+'"';
		modelviewer_html += ' autoplay';
		modelviewer_html += ' ar';
		modelviewer_html += ' ar-modes="webxr scene-viewer quick-look"';
		// modelviewer_html += ' ar-scale="fixed"';
		// modelviewer_html += ' touch-action="pan-y"';
		// camera-orbit="-30deg auto auto"
		// max-camera-orbit="auto 100deg auto"
		if( poster_src ) modelviewer_html += ' poster="'+htmlspecialchars(poster_src,true,true)+'"';
		modelviewer_html += '>';
		modelviewer_html += '<div slot="progress-bar" class="default-progress-bar" aria-hidden="true"><div class="bar" part="default-progress-bar"></div></div>\n';

		modelviewer_html += getModelViewerAutoDimensionsHTML(xopts);
		modelviewer_html += '</model-viewer>';
		modelviewer_html += getModelViewerAutoDimensionsStyle();
		// TODO: + environment-image="...hdr"
		// TODO: + alt=""

		md_trg
			.off('.MCModel')
			.html(modelviewer_html)
			.on('mjsclose.MCModel',function(e) {
				close_handler(e,true);
			})
			.on('mjsresize.MCModel',resize_handler);

		$md_modelviewer = md_trg.children('.md-model');
		let modelViewer = $md_modelviewer[0];


		modelViewer.addEventListener( 'load', ( event ) => {
			// console.log({w:'load',event});
			// eventually increase max-field-of-view (zoom-out range)
			if( modelViewer.getMaximumFieldOfView() < 90 ) {
				modelViewer.maxFieldOfView = '90deg';
			}
		} );

		modelViewer.addEventListener( 'progress', ( event ) => {
			// console.log({w:'progress',event});
			const progress = event.detail.totalProgress;
			const barElement = modelViewer.querySelector('.default-progress-bar > .bar');
			const parentNode = barElement.parentNode;
			requestAnimationFrame( () => {
				barElement.style.width = `${(100.0*progress).toFixed(2)}%`;
				if( progress===0 ) {
					parentNode.removeChild(barElement);
					parentNode.appendChild(barElement);
				}
				if( progress===1.0 ) barElement.classList.add('hide');
				else barElement.classList.remove('hide');
			} );
		} );

		modelViewer.addEventListener('render-scale', function( event ) {
			// console.log({w:'render-scale',event});
			// reportedDpr.textContent = event.detail.reportedDpr;
			// renderedDpr.textContent = event.detail.renderedDpr;
			// minimumDpr.textContent = event.detail.minimumDpr;
			// pixelWidth.textContent = event.detail.pixelWidth;
			// pixelHeight.textContent = event.detail.pixelHeight;
			// reason.textContent = event.detail.reason;
			invalidateCreatedPosterUrl();
		});

		// modelViewer.addEventListener('ar-status', function () {
			// invalidateCreatedPosterUrl();
		// });

		modelViewer.addEventListener('camera-change', function( event ) {
			// console.log({w:'camera-change',event});
			invalidateCreatedPosterUrl();
		});


		/* DISABLED - not ready yet
			function createPosterImage() {
				if( m_createdPosterUrl!='' ) {
					// re-use poster url ...
					return Promise.resolve(m_createdPosterUrl);
				} else if( m_createPosterImagePromise!==null ) {
					// wait until promise resolved ...
					return m_createPosterImagePromise;
				}

				// const orbit = modelViewer.getCameraOrbit();
				// const target = modelViewer.getCameraTarget();
				// const fov = modelViewer.getFieldOfView();
				// console.log({orbit,target,fov});
				// orbitString.textContent = `${orbit.theta}rad ${orbit.phi}rad auto`;

				m_createPosterImagePromise = new Promise( (resolve,reject) => {
					// modelViewer.fieldOfView = 'auto';
					// modelViewer.fieldOfView = fov;
					modelViewer.jumpCameraToGoal();
					requestAnimationFrame( () => {
						modelViewer.toBlob( {
							mimeType: 'image/png',
							qualityArgument: 0.9,
							//idealAspect: true,
						} ).then( (blob) => {
							// console.log({w:'set m_createdPosterUrl',m_createdPosterUrl,m_createPosterImagePromise});
							m_createdPosterUrl = URL.createObjectURL(blob);
							m_createPosterImagePromise = null;
							return resolve(m_createdPosterUrl);
						} );
					} );
				} ).finally( () => {
					// console.log({w:'finally m_createPosterImagePromise',m_createdPosterUrl,m_createPosterImagePromise});
					m_createPosterImagePromise = null;
				});
				return m_createPosterImagePromise;
			}

			// bind menu hover handler
			md_trg.on( 'mjsmenuhover.MCModel', function( event, which, menu, update_menu_cb ) {
				if( which==='download' && dtinfo.r_download ) {
					// provide rendered image for download
					var fn = media_id+'_'+media_class+'_rendered.png';

					const a = document.createElement('a');
					a.href = '#';
					a.className = 'loading disabled';
					a.download = fn;
					a.setAttribute('download',fn);
					a.appendChild( document.createTextNode(mjt('mdbt-download-x-poster','!')) );
					menu.children('a:first').after(a);
					createPosterImage().then( (tmpUrl) => {
						a.href = tmpUrl;
						a.className = '';
					} );
				}
				update_menu_cb(which,'after .MCModel);
			} );
		*/

		// md_trg.on( 'mjsmenuclose.MCModel', function( event, menu ) {
		// 	// console.log({w:'mjsmenuclose.MCModel',event,menu});
		// 	// invalidateCreatedPosterUrl();
		// } );


		setupModelViewerAutoDimensions( md_trg, modelViewer, xopts );

		resize_handler(null,md_trg.width(),md_trg.height());
	}

	return Object.assign( {}, MCUnknown, {

		getSourceDimensions: function( dtinfo ) {
			var meta = dtinfo.meta,
				has_custom_preview = meta[10] && meta[10][0] > 0,
				w = has_custom_preview && meta[10] ? parseInt(meta[10][0],10) : 1920,
				h = has_custom_preview && meta[11] ? parseInt(meta[11][0],10) : 1080,
				r = (w/h);
			return [w,h,r];
		},

		getPosterImageSrc: function( dtinfo, dsp_w, dsp_h, fill ) {
			var media_id = dtinfo.media_id;
			var meta = dtinfo.meta;
			var has_custom_preview = meta[10] && meta[10][0] > 0;
			var vq = !dtinfo.is_latest_version ? '&version='+encodeURIComponent(dtinfo.version) : '';
			var fq = '&transparency=1&bg_color=00000000';
			if( fill ) fq += '&fill=1';
			if( dsp_w===0 && dsp_h===0 ) {
				dsp_w = has_custom_preview && meta[10] ? parseInt(meta[10][0],10) : 1920;
				dsp_h = has_custom_preview && meta[11] ? parseInt(meta[11][0],10) : 1080;
			} else {
				for( var i=0; i<8 && (dsp_w<200&&dsp_h<200)||(dsp_w<100||dsp_h<100); ++i ) {
					dsp_w *= 2;
					dsp_h *= 2;
				}
				dsp_w = Math.floor(dsp_w);
				dsp_h = Math.floor(dsp_h);
			}
			return mj.fixAssetURL(
				has_custom_preview
					? mj.webroot+'media/file/custom_preview/id/'+media_id+'_'+media_class+'_0_'+dsp_w+'_'+dsp_h+'.png?cp_m='+encodeURIComponent(meta[12]?meta[12][0]:'')+'&m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq+fq
					: mj.webroot+'media/file/preview/id/'+media_id+'_'+media_class+'_1_'+dsp_w+'_'+dsp_h+'.png?m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')+vq+fq
			);
		},

		createPreview: function( dtinfo, target, xopts ) {
			const md_trg = $(target);
			disableMediaViewBGCtrlsToolbar( md_trg );

			if( !dtinfo.r_download ) {
				// eslint-disable-next-line no-console
				console.log({w:'NOTE: 3d model preview not available - download permissions required',media_id:dtinfo.media_id});
			} else {
				const meta = dtinfo.meta;
				const has_custom_preview = meta[10] && meta[10][0] > 0;
				const src_format = meta[-2]&&meta[-2][0] ? meta[-2][0] : 'application/octet-stream';
				if( !has_custom_preview && ( src_format==='model/gltf+json' || src_format==='model/gltf-binary' ) ) {
					let toolbarSetupUtil = new ToolbarSetupUtil();
					setupMediaViewBGCtrlsToolbar( md_trg, xopts, (toolbar) => toolbarSetupUtil.onToolbarSetup(toolbar) );
					if( loadModelViewerModule ) {
						return loadModelViewerModule( (module) => {

							module.ModelViewerElement.meshoptDecoderLocation = 'https://unpkg.com/meshoptimizer/meshopt_decoder.js';
							// module.ModelViewerElement.dracoDecoderLocation = 'http://example.com/location/of/draco/decoder/files/';
							// module.ModelViewerElement.ktx2TranscoderLocation = ...

							return createPreview_GLTF(dtinfo,target,xopts,toolbarSetupUtil);
						} );
					}
					return createPreview_GLTF(dtinfo,target,xopts,toolbarSetupUtil);
				}
			}
			// preview for anything else
			return MCUnknown.createPreview(dtinfo,target,xopts);
		},
	} );
}(jQuery,mj); // namespace MCModel
